import React from 'react';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons/faExclamationTriangle';

import Modal from './Modal.jsx';

const ModalConfirm = (props) => {
  const {
    show,
    icon,
    children,
    onReject = () => {},
    onConfirm = () => {},
  } = props;

  return (
    <Modal
      size="sm"
      show={show}
      onHide={onReject}
      centered
      className="p-4 text-center"
    >
      {icon !== null && (
        <div className="display-4 my-3 text-warning">
          <FA icon={icon || faExclamationTriangle} />
        </div>
      )}
      {children}
      <div className="form-row mt-4">
        <div className="col">
          <button
            className="btn btn-block btn-outline-warning"
            onClick={onReject}
          >
            Cancel
          </button>
        </div>
        <div className="col">
          <button
            className="btn btn-block btn-warning"
            onClick={onConfirm}
          >
            Confirm
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ModalConfirm;
